import { baseApi } from './baseApi';

const TAG = 'CalendarEvents';

const calendarAPI = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    fetchCalendarEvents: builder.query({
      query: ({ ...params } = {}) => ({
        url: '/calendar-events/',
        method: 'GET',
        params: {
          ...params,
          limit: 100,
        },
      }),
      transformResponse: (response) => {
        if (Array.isArray(response)) {
          return response;
        }
        if (response?.results) {
          return response.results;
        }
        return [];
      },
      providesTags: [TAG],
    }),
    fetchUpcomingEvents: builder.query({
      query: () => ({
        url: '/calendar-events/',
        method: 'GET',
        params: {
          start_date: new Date().toISOString().split('T')[0],
          sort: 'start_time',
          limit: 5,
        },
      }),
      transformResponse: (response) => {
        if (Array.isArray(response)) {
          return response;
        }
        return response?.results || [];
      },
      providesTags: [TAG],
    }),
    fetchCalendarEvent: builder.query({
      query: ({ id }) => ({
        url: `/calendar-events/${id}/`,
        method: 'GET',
      }),
      providesTags: (result, error, arg) => (result ? [{ type: TAG, id: arg.id }, TAG] : [TAG]),
    }),
    createCalendarEvent: builder.mutation({
      query: (data) => ({
        url: '/calendar-events/',
        method: 'POST',
        body: data,
      }),
      invalidatesTags: [TAG],
    }),
    updateCalendarEvent: builder.mutation({
      query: ({ id, ...params }) => ({
        url: `/calendar-events/${id}/`,
        method: 'PUT',
        body: params,
      }),
      invalidatesTags: (result, error, arg) => [TAG, { type: TAG, id: arg.id }],
    }),
    patchCalendarEvent: builder.mutation({
      query: ({ id, ...params }) => ({
        url: `/calendar-events/${id}/`,
        method: 'PATCH',
        body: params,
      }),
      invalidatesTags: (result, error, arg) => [TAG, { type: TAG, id: arg.id }],
    }),
    deleteCalendarEvent: builder.mutation({
      query: ({ id }) => ({
        url: `/calendar-events/${id}/`,
        method: 'DELETE',
      }),
      invalidatesTags: [TAG],
    }),
  }),
});

export const {
  useFetchCalendarEventsQuery,
  useLazyFetchCalendarEventsQuery,
  useFetchCalendarEventQuery,
  useLazyFetchCalendarEventQuery,
  useCreateCalendarEventMutation,
  useUpdateCalendarEventMutation,
  usePatchCalendarEventMutation,
  useDeleteCalendarEventMutation,
  useFetchUpcomingEventsQuery,
} = calendarAPI;
